<ion-header>
  <ion-toolbar>
    <ion-title>Add Address</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()" [strong]="true"
        >Close</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card style="background-color: #f4f4ff">
    <ion-card-content>
      <form (submit)="handlerForm()" [formGroup]="addressForm">
        <ion-row>
          <ion-col>
            <ion-label class="spx-font-black">
              House / Flat / Block No.
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-bottom">
          <ion-col class="input-background ion-no-padding p-5" size="12">
            <ion-input
              type="text"
              class="spx-font-16 ion-no-padding"
              style="background: transparent; outline: none; border: 0"
              name="name"
              formControlName="houseFlatBlock"
            ></ion-input>
          </ion-col>
        </ion-row>
        <div
          *ngIf="
            addressForm.controls['houseFlatBlock'].invalid &&
            (addressForm.controls['houseFlatBlock'].dirty ||
              addressForm.controls['houseFlatBlock'].touched)
          "
          class="spx-color-red"
        >
          <div
            *ngIf="addressForm.controls['houseFlatBlock'].hasError('pattern')"
            class="spx-font-14"
          >
            House / Flat / Block No. is invalid.
          </div>
          <div
            *ngIf="addressForm.controls['houseFlatBlock'].hasError('required')"
            class="spx-font-14"
          >
            House / Flat / Block No. is required.
          </div>
        </div>
        <ion-row>
          <ion-col>
            <ion-label class="spx-font-black">
              Apartment / Road / Area
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-bottom">
          <ion-col size="12" class="input-background ion-no-padding p-5">
            <ion-input
              type="text"
              class="spx-font-16 ion-no-padding"
              style="background: transparent; outline: none; border: 0"
              name="name"
              [(ngModel)]="destinationAddress"
              appAutocomplete
              (onSelect)="onAddressSelect($event)"
              (ionInput)="onAddressInput()"
              formControlName="apartmentRoadArea"
            ></ion-input>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-no-padding">
            <ion-list
              *ngIf="
                (autocompleteResults.length && destinationAddress.length) > 0
              "
              class="dropdown"
              lines="full"
            >
              <ion-item
                *ngFor="let result of autocompleteResults"
                (click)="onAddressSelect(result)"
              >
                <div class="result-description">
                  {{ result.description }}
                </div>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
        <div
          *ngIf="
            addressForm.controls['apartmentRoadArea'].invalid &&
            (addressForm.controls['apartmentRoadArea'].dirty ||
              addressForm.controls['apartmentRoadArea'].touched)
          "
          class="spx-color-red"
        >
          <div
            *ngIf="
              addressForm.controls['apartmentRoadArea'].hasError('pattern')
            "
            class="spx-font-14"
          >
            Apartment / Road / Area is invalid.
          </div>
          <div
            *ngIf="
              addressForm.controls['apartmentRoadArea'].hasError('required')
            "
            class="spx-font-14"
          >
            Apartment / Road / Area is required.
          </div>
        </div>

        <ion-row>
          <ion-col size="5.5">
            <ion-label class="spx-font-black">
              City
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
          <ion-col size="1"></ion-col>
          <ion-col size="5.5">
            <ion-label class="spx-font-black">
              State
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-bottom">
          <ion-col size="5.5">
            <ion-row class="input-background ion-no-padding p-5">
              <ion-col class="ion-no-padding">
                <ion-input
                  type="text"
                  class="spx-font-16 ion-no-padding"
                  style="background: transparent; outline: none; border: 0"
                  name="city"
                  formControlName="city"
                ></ion-input>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="
                addressForm.controls['city'].invalid &&
                (addressForm.controls['city'].dirty ||
                  addressForm.controls['city'].touched)
              "
              class="spx-color-red"
            >
              <ion-col class="ion-no-padding">
                <div
                  *ngIf="addressForm.controls['city'].hasError('pattern')"
                  class="spx-font-14"
                >
                  City is invalid.
                </div>
                <div
                  *ngIf="addressForm.controls['city'].hasError('required')"
                  class="spx-font-14"
                >
                  City is required.
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size="1"></ion-col>
          <ion-col size="5.5">
            <ion-row class="input-background ion-no-padding p-5">
              <ion-input
                type="text"
                class="spx-font-16 ion-no-padding"
                style="background: transparent; outline: none; border: 0"
                name="state"
                formControlName="state"
              ></ion-input>
            </ion-row>
            <ion-row
              *ngIf="
                addressForm.controls['state'].invalid &&
                (addressForm.controls['state'].dirty ||
                  addressForm.controls['state'].touched)
              "
              class="spx-color-red"
              ><ion-col class="ion-no-padding">
                <div
                  *ngIf="addressForm.controls['state'].hasError('pattern')"
                  class="spx-font-14"
                >
                  State is invalid.
                </div>
                <div
                  *ngIf="addressForm.controls['state'].hasError('required')"
                  class="spx-font-14"
                >
                  State is required.
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="mt--5">
          <ion-col size="5.5">
            <ion-label class="spx-font-black">
              Zip Code
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
          <ion-col size="1"></ion-col>
          <ion-col size="5.5">
            <ion-label class="spx-font-black">
              Country
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-bottom">
          <ion-col size="5.5">
            <ion-row class="input-background ion-no-padding p-5">
              <ion-col class="ion-no-padding">
                <ion-input
                  type="text"
                  class="spx-font-16 ion-no-padding"
                  style="background: transparent; outline: none; border: 0"
                  name="name"
                  formControlName="pin"
                  maxlength="6"
                ></ion-input>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="
                addressForm.controls['pin'].invalid &&
                (addressForm.controls['pin'].dirty ||
                  addressForm.controls['pin'].touched)
              "
              class="spx-color-red"
            >
              <ion-col class="ion-no-padding">
                <div
                  *ngIf="addressForm.controls['pin'].hasError('pattern')"
                  class="spx-font-14"
                >
                  Zip Code is invalid.
                </div>
                <div
                  *ngIf="addressForm.controls['pin'].hasError('required')"
                  class="spx-font-14"
                >
                  Zip Code is required.
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size="1"></ion-col>
          <ion-col size="5.5">
            <ion-row class="input-background ion-no-padding p-5">
              <ion-input
                type="text"
                class="spx-font-16 ion-no-padding"
                style="background: transparent; outline: none; border: 0"
                name="name"
                formControlName="country"
              ></ion-input
            ></ion-row>
            <ion-row
              *ngIf="
                addressForm.controls['country'].invalid &&
                (addressForm.controls['country'].dirty ||
                  addressForm.controls['country'].touched)
              "
              class="spx-color-red"
            >
              <div
                *ngIf="addressForm.controls['country'].hasError('pattern')"
                class="spx-font-14"
              >
                Country is invalid.
              </div>
              <div
                *ngIf="addressForm.controls['country'].hasError('required')"
                class="spx-font-14"
              >
                Country is required.
              </div>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row class="mt--5">
          <ion-col>
            <ion-label class="spx-font-black">
              Choose Address Type
              <span class="spx-color-red">*</span>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="button-row">
          <ion-col class="ion-no-padding">
            <ion-list class="options ion-no-padding">
              <ion-row>
                <ion-col
                  class="ion-no-padding addressTag"
                  size="auto"
                  *ngFor="let tag of addressTags"
                >
                  <ion-button
                    (click)="selectTag(tag)"
                    [color]="selectedTag === tag.label ? 'primary' : 'medium'"
                    [disabled]="tagSet.has(tag.value.toUpperCase())"
                  >
                    {{ tag.label }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-list>
          </ion-col>
        </ion-row>
        <ion-row
          class="input-background ion-no-padding p-5"
          style="margin-top: 5px"
          *ngIf="selectedTag == 'Other'"
        >
          <ion-col class="ion-no-padding">
            <ion-input
              class="spx-font-16 ion-no-padding"
              placeholder="Enter other value"
              formControlName="addressTag"
            ></ion-input>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="
            selectedTag == 'Other' &&
            addressForm.controls['addressTag'].invalid &&
            (addressForm.controls['addressTag'].dirty ||
              addressForm.controls['addressTag'].touched)
          "
          class="spx-color-red"
        >
          <ion-col class="ion-no-padding">
            <div
              *ngIf="addressForm.controls['addressTag'].hasError('pattern')"
              class="spx-font-14"
            >
              Tag invalid.
            </div>
            <div
              *ngIf="addressForm.controls['addressTag'].hasError('required')"
              class="spx-font-14"
            >
              Tag required.
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-button
              expand="block"
              type="submit"
              [disabled]="!addressForm.valid"
              >Save Address</ion-button
            >
          </ion-col>
        </ion-row>
      </form>
    </ion-card-content>
  </ion-card>
</ion-content>
